export default __webpack_public_path__ + "static/media/DtVmJx26TKEr37c9YL5rik8s6yLUrwB0lw.7d759c09.woff2";